import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createBlock, resolveDynamicComponent, normalizeClass, withCtx, createTextVNode, toDisplayString } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductBadge",
  props: {
    type: {
      default: ""
    },
    badge: {},
    enableClick: {
      type: Boolean,
      default: true
    },
    modalTitle: {
      default: ""
    },
    componentURI: {
      default: ""
    },
    modalContent: {
      default: ""
    }
  },
  emits: ["badgeClick", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const computedClass = computed(() => {
      const toKebabCase = (str) => {
        var _a;
        return (_a = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) == null ? void 0 : _a.map((x) => x.toLowerCase()).join("-");
      };
      if (props.badge.badgeText) return `product-badge--${toKebabCase(props.badge.badgeText)}`;
      return "";
    });
    const cssVars = computed(() => ({
      "--badge-color": props.badge.color
    }));
    const handleBadgeClick = () => {
      emit("badgeClick", props.badge);
      emit("metricsClick", {
        linkName: `badge_${props.badge.analyticName}`
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        style: normalizeStyle(cssVars.value)
      }, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.enableClick ? "button" : "div"), {
        class: normalizeClass(["product-badge", computedClass.value, {
          "product-badge--badge-only": !_ctx.enableClick
        }]),
        "aria-haspopup": _ctx.enableClick ? "dialog" : void 0,
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.enableClick && handleBadgeClick())
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.badge.badgeText), 1)]),
        _: 1
      }, 8, ["class", "aria-haspopup"]))], 4);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductBadge2.mjs.map
